import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { PagedResult } from '@/api/client';
import type { AuditLogEntry, StockLog, StockLogType } from '@/api/types';

interface AuditQuery {
  eventName?: string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
  [key: string]: string | number | boolean | null | undefined;
}

/** Who did what, inside this pharmacy. Tenant-scoped — see /api/superadmin/audit-log for the platform-wide version. */
export function useAuditLog(query: AuditQuery = {}) {
  return useQuery({
    queryKey: ['audit', query],
    queryFn: () => api.get<PagedResult<AuditLogEntry>>('/api/audit', query),
  });
}

interface StockLogQuery {
  type?: StockLogType;
  page?: number;
  limit?: number;
  [key: string]: string | number | boolean | null | undefined;
}

/** Every stock movement across the pharmacy — additions, sales, restocks, adjustments, expiry removals. */
export function useStockLogs(query: StockLogQuery = {}) {
  return useQuery({
    queryKey: ['stock-logs', query],
    queryFn: () => api.get<PagedResult<StockLog>>('/api/stock-logs', query),
  });
}
